<app-spinner-container [isLoading]="form ==null || form == undefined">
    <form *ngIf="form" [formGroup]="form">
        <mat-card
                appCard
                style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
        >
            <mat-card-header class="titree">
                {{ "Informations utilisateur" | translate }}
            </mat-card-header>

            <mat-card-content class="card-content">
                <div
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        style="
          max-width: 100%;
          justify-content: center;
          margin-bottom: 1%;
          margin-left: 1%;
          margin-top: 1%;
        "
                >
                    <div class="cp5" fxLayout="row wrap" fxLayoutAlign="flex-start center">
                        <div fxFlex="50" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('bizRegNo')"
                                    [label]="'N° registre commerce'"
                            ></app-text-field>
                        </div>
                        <div fxFlex="50" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('supplierNm')"
                                    [label]="'Nom société'"
                            ></app-text-field>
                        </div>

                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('staffNm')"
                                    [label]="'Nom et prénom'"
                            ></app-text-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <ng-template [ngIfElse]="fouTem" [ngIfThen]="achTem" [ngIf]="acheteur"></ng-template>
                            <ng-template #achTem>
                                <app-text-field
                                        [control]="get('indRegNo')"
                                        [label]="'N° CIN'"
                                        [max]="8"
                                        [number]="true"
                                ></app-text-field>
                            </ng-template>
                            <ng-template #fouTem>
                                <app-text-field
                                        [control]="get('indRegNo')"
                                        [label]="((infoUser?.isTunisian!=='Y')?'N° Passeport':'N° CIN')"
                                        [max]="(infoUser?.isTunisian=='Y'?8:null)"
                                        [number]="infoUser?.isTunisian==='Y'"
                                ></app-text-field>
                            </ng-template>

                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-select-date
                                    [control]="get('issuedYmdStr')"
                                    [label]="'Date délivrance'"
                                    [max]="currentDate"
                            >
                            </app-select-date>
                        </div>

                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('staffDeptNm')"
                                    [label]="'Département'"
                            ></app-text-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('positionNm')"
                                    [label]="'Fonction'"
                            ></app-text-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('telNo')"
                                    [label]="'N° téléphone fixe'"
                                    [numberphone]="true"
                            ></app-text-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('faxNo')"
                                    [label]="'N° fax'"
                                    [numberphone]="true"
                            ></app-text-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('mtelNo')"
                                    [label]="'N° téléphone portable'"
                                    [numberphone]="true"
                            ></app-text-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100">
                            <app-text-field
                                    [control]="get('email')"
                                    [label]="'Email'"
                            ></app-text-field>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card
                appCard
                style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
        >
            <mat-card-header class="titree">
                {{ "Droit(s) utilisateur" | translate }}
            </mat-card-header>
            <mat-card-content class="card-content">
                <div
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        style="
          max-width: 100%;
          justify-content: center;
          margin-bottom: 1%;
          margin-left: 1%;
          margin-top: 1%;
        "
                >
                    <div class="cp5" fxLayout="row wrap" fxLayoutAlign="flex-start center">
                        <div *ngIf="!acheteur" fxFlex="33" fxFlex.lt-md="100">
                            <mat-checkbox [disabled]="disabled" formControlName="j"
                            >{{ "Administrateur par fournisseur(j)" | translate }}
                            </mat-checkbox>
                        </div>

                        <div *ngIf="acheteur" fxFlex="33" fxFlex.lt-md="100">
                            <mat-checkbox [disabled]="disabled" formControlName="h"
                            >{{ "Administrateur par acheteur(h)" | translate }}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <div *ngIf="certiflocalbool" style="margin-top: 3%">
            <app-spinner-container [isLoading]="loading.list">
                <mat-card appCard
                          style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
                    <mat-card-content class="card-content">
                        <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
                            <table [dataSource]="dataSource" mat-table style="width: 100%">
                                <ng-container
                                        *ngFor="let column of readColumns"
                                        [matColumnDef]="column"
                                >
                                    <th *matHeaderCellDef mat-header-cell translate>
                                        {{ labels[column] }}
                                    </th>
                                    <td *matCellDef="let type" mat-cell translate>
                                        {{ type[column] }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="action">
                                    <th *matHeaderCellDef mat-header-cell>{{'Plus de détails' | translate}}</th>
                                    <td *matCellDef="let certif" mat-cell>
                                        <a (click)="openCertif(certif)" mat-icon-button>
                                            <mat-icon style="color: #00a8ff">add_circle</mat-icon>
                                        </a>
                                    </td>
                                </ng-container>
                                <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                                <tr
                                        (click)="selection.toggle(row)"
                                        (click)="toggle()"
                                        (mouseout)="row.hovered = false"
                                        (mouseover)="row.hovered = true"
                                        *matRowDef="let row; columns: displayedColumns"
                                        [ngClass]="{
            hovered: row.hovered,
            highlighted: selection.isSelected(row)
          }"
                                        mat-row
                                ></tr>
                            </table>
                        </div>
                    </mat-card-content>
                </mat-card>

                <app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
            </app-spinner-container>
        </div>
        <div class="cp5 " fxLayout="row wrap" fxLayoutAlign="end end" style="padding-top: 5px">

            <div fxLayoutAlign="end end">
                <button

                        (click)="onSuccess()"
                        [disabled]="disabled_conn || loading.list"
                        color="primary"
                        mat-raised-button
                >
                    <span translate>submit</span>
                </button>
            </div>
            <div fxLayoutAlign="end end">
                <button
                        (click)="onPrecedent()"
                        color="primary"
                        mat-raised-button

                        style="background-color: #3e90d0; color: white"
                >
                    <span translate>Précédent</span>
                </button>
            </div>
        </div>
    </form>

</app-spinner-container>
